import PageHeader from 'components/common/PageHeader';
import AdvanceTablePagination from 'components/common/usersTable/AdvanceTablePagination';
import dayjs from 'dayjs';
import moment from 'moment';
import 'moment/locale/es';
import { useEffect, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { getBranchOfficesByUserId } from 'redux/branchOfficeSlice';
import { getProjectsByFilters } from 'redux/projectsSlice';
import ButtonCreate from 'utils/buttons/ButtonCreate';
import { checkPermission } from 'utils/checkPermission';
import { informacion } from '../gestionarPropiedades/propertyWizard/steps/data/props';
import { projectColumns } from './projectWizard/steps/data/projects';
import ProjectsCards from './tables/ProjectsCards';
import ProjectsTable from './tables/ProjectsTable';
import ListFilterComponent from './tables/components/ListFilterComponent';
import ListOrderComponent from './tables/components/ListOrderComponent';
import { ProjectActions } from './tables/components/ProjectActions';
import {
  getRealEstateByUserId,
  getRealEstateProjectStats
} from 'redux/realEstateSlice';
import WidgetProjectStats from '../gestionarInmobiliaria/components/WidgetProjectStats';
import SelectBarProject from './tables/components/SelectBarProject/SelectBarProject';

moment.locale('es');

export const propStatusObj = {
  pending: 'Pendiente',
  published: 'Activa',
  paused: 'Pausada',
  deleted: 'Eliminada',
  finished: 'Finalizada'
};

const MyProjects = () => {
  //Parametro traido desde la URL para obtener el filtro viniendo desde el componente resumen -- Conrado
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const filtro = queryParams.get('filtro');
  //Hooks e informacion base del usuario
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userLogged = useSelector(state => state.login.currentUser);
  const branchOffices = useSelector(state => state.branchOffice.branchOffices);
  const rolesUser = useSelector(state => state.roles.rolesById);

  const permisos = [];
  if (userLogged?.typeOfUser !== 'admin') {
    userLogged?.roles?.map(roles =>
      rolesUser[roles.id]?.roleToPermission.map(
        permiso =>
          permisos.indexOf(permiso.permission.id) === -1 &&
          permisos.push(permiso.permission.id)
      )
    );
  }

  // State con array de elementos seleccionados
  const [selected, setSelected] = useState([]);

  //State para render
  const [checkChanges, setCheckChanges] = useState(false);

  //Estado base
  const [data, setData] = useState();

  //Estado para oficina actual y lista de props
  const { neighborhoodsObj } = useSelector(state => state.props);
  const { branchOfficeProjects: projects } = useSelector(
    state => state.projects
  );

  const { realEstate } = useSelector(state => state.realEstate);

  const [loading, setLoading] = useState(true);

  //Estados para paginacion
  const [page, setPage] = useState({ number: 1 });
  const [propsLimit, setPropsLimit] = useState(10);
  const [totalProps, setTotalProps] = useState(0);
  const [filtersAndSort, setFiltersAndSort] = useState({
    branchOffices: [],
    status: filtro !== null ? [filtro] : [],
    propertyTypes: [],
    operation: 0,
    shared: 'all',
    sortBy: {
      prop: 'updated_at',
      order: 'asc'
    },
    neighborhoods: [],
    price: {
      min: '',
      max: '',
      currency: 'ARS'
    },
    surface: {
      min: '',
      max: '',
      type: 'totalSurface'
    },
    ambiences: [],
    bedrooms: [],
    bathrooms: [],
    garages: [],
    deadline: {
      from: '',
      to: ''
    },
    project_status: ''
  });

  //Estado para búsqueda
  const [searchProp, setSearchProp] = useState('');
  const [searchAddress, setSearchAddress] = useState('');

  //filtrado y sort de propiedades mostradas
  const [filtredProps, setFiltredProps] = useState(projects?.list);

  const [type, setType] = useState('cards');

  const canNextPage = Math.ceil(totalProps / propsLimit) > page.number;
  const canPreviousPage = page.number > 1;

  const nextPage = () => {
    setPage(prev => ({ number: prev.number + 1 }));
  };

  const previousPage = () => {
    setPage(prev => ({ number: prev.number - 1 }));
  };

  const submitSearch = value => {
    setSearchProp(value);
  };
  const submitSearchAddress = value => {
    setSearchAddress(value);
  };

  const HandleCheckbox = () => {
    if (selected.length > 0) setSelected([]);
    else
      setSelected(
        data.map(prop => ({
          id: prop.id,
          title: prop.title,
          status: prop.status
        }))
      );
  };

  //Get Branch Offices
  useEffect(() => {
    if (userLogged) {
      dispatch(getBranchOfficesByUserId(userLogged.id));
      dispatch(getRealEstateByUserId(userLogged.id));
    }
  }, [userLogged]);

  useEffect(async () => {
    if (branchOffices && page && filtersAndSort && propsLimit && checkChanges) {
      let newFilterAndSort = { ...filtersAndSort };

      if (filtersAndSort.branchOffices.length === 0) {
        newFilterAndSort = {
          ...filtersAndSort,
          branchOffices: branchOffices.map(branch => branch.id)
        };
      }

      await dispatch(
        getProjectsByFilters(
          newFilterAndSort,
          page.number,
          propsLimit,
          searchProp,
          searchAddress
        )
      );
      setLoading(false);
      dispatch(getRealEstateProjectStats(realEstate.id));
      setCheckChanges(false);
    }
  }, [checkChanges]);

  useEffect(() => {
    setPage({ number: 1 });
    setCheckChanges(true);
  }, [branchOffices, filtersAndSort, propsLimit, searchProp, searchAddress]);
  //inicializo las dos listas de propiedades en base a la lista actual
  useEffect(() => {
    if (projects) {
      setFiltredProps(projects.list);
      setTotalProps(projects?.length);
    }
  }, [projects]);

  useEffect(() => {
    if (filtredProps) {
      const array = filtredProps?.map(project => {
        const mappedObj = {
          id: project._id,
          title: project.title,
          images: project.images,
          address: `${project.location.street} ${project.location.number}`,
          barrios: neighborhoodsObj[project.location.barrios?.at(-1)],
          updated_at: dayjs(project.updated_at).format('DD/MM/YYYY HH:mm [hs]'),
          created_at: dayjs(project.updated_at).format('DD/MM/YYYY HH:mm [hs]'),
          type: informacion.property[project.property_type],
          status: propStatusObj[project.status],
          statistics: project.statistics,
          actions: (
            <ProjectActions
              project={project}
              userLogged={userLogged}
              setCheckChanges={setCheckChanges}
            />
          ),
          share: project.share,
          builder: project.builder,
          info: project.info,
          rawProp: project
        };

        return mappedObj;
      });

      setData(array);
    }
  }, [filtredProps]);

  return (
    <>
      {userLogged && branchOffices && (
        <>
          <Row style={{ display: 'flex', alignItems: 'stretch' }}>
            <Col xs={12} md={7} style={{ display: 'flex' }}>
              <PageHeader
                title="Mis Emprendimientos"
                description="Mantenga al día el estado de sus emprendimientos, así como sus fotografías, y no descuide los mensajes de los interesados."
                className="mb-3 bg-white"
              >
                {userLogged &&
                  checkPermission('Create properties', userLogged) && (
                    <ButtonCreate
                      className="w-100 w-lg-auto"
                      text="Nuevo Emprendimiento"
                      funcion={() => navigate('/emprendimientos/cargar')}
                      variant="primary"
                    />
                  )}
              </PageHeader>
            </Col>
            <Col xs={12} md={5} style={{ display: 'flex' }}>
              <WidgetProjectStats title="Emprendimientos" />
            </Col>
          </Row>

          <Row className="g-3">
            <Col xs={12} lg={3} xxl={2}>
              <ListFilterComponent
                filtersAndSort={filtersAndSort}
                setFiltersAndSort={setFiltersAndSort}
                branchOffices={branchOffices}
                submitSearch={submitSearch}
                searchAddress={submitSearchAddress}
                searchingAddress={!!searchAddress}
                searching={!!searchProp}
                neighborhoods={projects.neighborhoods}
              />
            </Col>

            <Col xs={12} lg={9} xxl={10}>
              <Row className="g-1">
                <Col xs={12}>
                  <ListOrderComponent
                    type={type}
                    setType={setType}
                    page={page.number}
                    propsLimit={propsLimit}
                    setPropsLimit={setPropsLimit}
                    totalProps={totalProps}
                    filtersAndSort={filtersAndSort}
                    setFiltersAndSort={setFiltersAndSort}
                    rowsPerPageOptions={[10, 15, 20, 25]}
                    loading={loading}
                  />
                </Col>

                <Col xs={12}>
                  <SelectBarProject
                    selected={selected}
                    setSelected={setSelected}
                    handleCheckbox={HandleCheckbox}
                    setCheckChanges={setCheckChanges}
                  />
                </Col>

                <Col
                  xs={12}
                  style={{
                    minHeight: '400px'
                  }}
                >
                  {loading ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%'
                      }}
                    >
                      <Spinner
                        animation="border"
                        style={{
                          color: '#2c7be5'
                        }}
                      />
                    </div>
                  ) : (
                    data &&
                    projectColumns &&
                    (type === 'table' ? (
                      <ProjectsTable
                        data={data}
                        propsLimit={Number(propsLimit)}
                        columns={projectColumns}
                        filtersAndSort={filtersAndSort}
                        setFiltersAndSort={setFiltersAndSort}
                        loading={loading}
                        type="project"
                      />
                    ) : (
                      <ProjectsCards
                        projects={data}
                        loading={loading}
                        propsLimit={Number(propsLimit)}
                        selected={selected}
                        setSelected={setSelected}
                      />
                    ))
                  )}
                </Col>

                <Col xs={12} className="pt-2">
                  <AdvanceTablePagination
                    canNextPage={canNextPage}
                    canPreviousPage={canPreviousPage}
                    pageCount={Math.ceil(totalProps / propsLimit)}
                    gotoPage={page => setPage({ number: page + 1 })}
                    nextPage={nextPage}
                    pageIndex={page.number - 1}
                    previousPage={previousPage}
                    setCheckChanges={setCheckChanges}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default MyProjects;
